import React from 'react';
import Tooltip from '../tooltip/Tooltip';

interface TruncatedTextWithTooltipProps {
  text: string | null | undefined;
  children: React.ReactNode;
  position?: 'top' | 'right' | 'bottom' | 'left' | 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Envuelve contenido de texto con truncamiento CSS (ellipsis) y muestra el texto
 * completo via Tooltip estilizado al hacer hover.
 * Usa React Portal internamente para funcionar dentro de contenedores
 * con overflow: hidden (ej. celdas de react-data-table-component).
 */
const TruncatedTextWithTooltip: React.FC<TruncatedTextWithTooltipProps> = ({
  text,
  children,
  position = 'top',
  className,
  style,
}) => {
  const displayText = text || '';

  return (
    <Tooltip position={position} msg={displayText}>
      <div
        className={className}
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'block',
          maxWidth: '100%',
          width: '100%',
          ...style,
        }}
      >
        {children}
      </div>
    </Tooltip>
  );
};

export default TruncatedTextWithTooltip;
